{
  "version": 1,
  "asset_id": "8812701a-4650-4a34-bd42-c986172a57e7",
  "project_id": "63ffb125-aed4-4f54-959a-0b116fa77b1d",
  "url": "/__l5e/assets-v1/8812701a-4650-4a34-bd42-c986172a57e7/bypass-revision-resection-en-1200.webp",
  "r2_key": "a/v1/63ffb125-aed4-4f54-959a-0b116fa77b1d/8812701a-4650-4a34-bd42-c986172a57e7/bypass-revision-resection-en-1200.webp",
  "original_filename": "bypass-revision-resection-en-1200.webp",
  "size": 138932,
  "content_type": "image/webp",
  "created_at": "2026-10-05T22:41:31Z"
}
